import { c as _c } from "react/compiler-runtime";
import type { DocumentViewerCardContentTableData } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type TableContentProps = {
  content: DocumentViewerCardContentTableData;
};
const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '-';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};
const TableContent = t0 => {
  const $ = _c(19);
  const {
    content
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  const {
    columnsDefinition,
    rows
  } = content;
  if (rows.length === 0) {
    let t1;
    if ($[0] !== t) {
      t1 = t(_temp);
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <p className="text-caption-2 text-tertiary py-2">{t1}</p>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== columnsDefinition) {
    let t2;
    if ($[6] !== columnsDefinition.length) {
      t2 = (col, index) => <div key={col.fieldName} className={cx("p-2 text-caption-1 text-tertiary", {
        "flex-1": index < columnsDefinition.length - 1,
        "w-20": index === columnsDefinition.length - 1
      })}>{col.columnName}</div>;
      $[6] = columnsDefinition.length;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = columnsDefinition.map(t2);
    $[4] = columnsDefinition;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div className="flex border-b border-tertiary">{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== columnsDefinition || $[11] !== rows) {
    let t4;
    if ($[13] !== columnsDefinition || $[14] !== rows.length) {
      t4 = (row, rowIndex) => {
        const isLast = rowIndex === rows.length - 1;
        const rowKey = columnsDefinition.map(col_0 => formatValue(row[col_0.fieldName])).join("-");
        return <div key={rowKey} className={cx("flex", {
          "border-b border-tertiary": !isLast
        })}>{columnsDefinition.map((col_1, colIndex) => <div key={col_1.fieldName} className={cx("p-2 text-caption-2 text-primary", {
            "flex-1": colIndex < columnsDefinition.length - 1,
            "w-20": colIndex === columnsDefinition.length - 1
          })}>{formatValue(row[col_1.fieldName])}</div>)}</div>;
      };
      $[13] = columnsDefinition;
      $[14] = rows.length;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t3 = rows.map(t4);
    $[10] = columnsDefinition;
    $[11] = rows;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[16] !== t2 || $[17] !== t3) {
    t4 = <div className="w-full">{t2}{t3}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};
export default TableContent;
function _temp($) {
  return $.table.noData;
}